import Color from 'colorjs.io'
import type { OklchColor } from './types'

export const oklchToCSS = (oklch: OklchColor) =>
  new Color('oklch', [oklch.l, oklch.c, oklch.h], oklch.alpha).toString()

export const hexToOklch = (hex: string): OklchColor => {
  const color = new Color(hex)
  const oklch = color.to('oklch')
  return {
    l: oklch.coords[0] ?? 0.5,
    c: oklch.coords[1] ?? 0.2,
    h: oklch.coords[2] ?? 0,
    alpha: oklch.alpha,
  }
}

export const oklchToHex = (oklch: OklchColor): string => {
  const color = new Color('oklch', [oklch.l, oklch.c, oklch.h], oklch.alpha)
  return color.to('srgb').toString({ format: 'hex' })
}
